import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getGymBalance } from '../../Redux/Actions/actions';
import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, CartesianGrid, Legend } from 'recharts';

import styles from './Statistics.module.css';

const Statistics = () => {
  const dispatch = useDispatch();
  const gymId = useSelector((state) => state.gym.id);
const gymBalance = useSelector((state) => state.gymBalance);
const detalle = gymBalance?.detalle || [];
const total = gymBalance?.total || 0;
const pagos = gymBalance?.pagos || 0;


  

  useEffect(() => {
    if (gymId) dispatch(getGymBalance(gymId));
  }, [dispatch, gymId]);

  // Agrupar pagos por mes
  const monthlyData = detalle.reduce((acc, payment) => {
    const month = new Date(payment.payment_date).toLocaleString('default', { month: 'short', year: 'numeric' });
    const existing = acc.find(item => item.month === month);
    if (existing) {
      existing.amount += Number(payment.amount);
    } else {
      acc.push({ month, amount: Number(payment.amount) });
    }
    return acc;
  }, []);

  return (
    <div className={styles.container}>
      <h1 className={styles.title}>Estadísticas Financieras</h1>

      <div className={styles.chartContainer}>
        <h2>Ingresos Mensuales</h2>
        <ResponsiveContainer width="100%" height={300}>
          <BarChart data={monthlyData}>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="month" stroke="#000" />
            <YAxis stroke="#000" />
            <Tooltip />
            <Legend />
            <Bar dataKey="amount" fill="#d90429" />
          </BarChart>
        </ResponsiveContainer>
      </div>

      <div className={styles.summaryBox}>
        <p><strong>Total Ingresado:</strong> ${total}</p>
        <p><strong>Cantidad de Pagos:</strong> {pagos}</p>
      </div>

      <h2>Detalle de Pagos</h2>
      <div className={styles.tableContainer}>
        <table className={styles.table}>
          <thead>
            <tr>
              <th>Usuario</th>
              <th>DNI</th>
              <th>Monto</th>
              <th>Fecha</th>
              <th>Método</th>
              <th>Notas</th>
            </tr>
          </thead>
          <tbody>
            {detalle.map((pago) => (
              <tr key={pago.id}>
                <td>{pago.user?.name} {pago.user?.last_name}</td>
                <td>{pago.user?.dni}</td>
                <td>${pago.amount}</td>
                <td>{new Date(pago.payment_date).toLocaleDateString()}</td>
                <td>{pago.payment_method}</td>
                <td>{pago.notes || '-'}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default Statistics;
